import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Index from "./pages/Index";
import CB from "./pages/CB";
import Alt from "./pages/Alt";
import NotFound from "./pages/NotFound";
import { useFathom } from "./hooks/useFathom";

const queryClient = new QueryClient();

const AppRoutes = () => {
  useFathom();
  return (
    <Routes>
      {/* Alt is now the live homepage; the previous homepage is archived at /old */}
      <Route path="/" element={<Alt />} />
      <Route path="/cb" element={<CB />} />
      <Route path="/old" element={<Index />} />
      {/* /alt moved to / — redirect any old review links */}
      <Route path="/alt" element={<Navigate to="/" replace />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
